var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 76,
    viewBox: "0 0 189 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2612_17545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 165,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.112 12.8394H12.7148V62.7599H176.112V12.8394Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2612_17545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.271 51.2613C120.35 51.2613 125.463 46.4072 125.463 37.8761C125.463 29.345 120.471 24.5392 113.609 24.6037C109.166 24.6037 105.812 26.4906 104.062 29.6756V25.2164H98.168V57.4944H104.344V46.6813C105.981 49.4793 109.013 51.2533 113.279 51.2533L113.271 51.2613ZM104.514 37.5455C104.514 32.53 107.949 30.1836 111.714 30.1836C115.98 30.1836 119.076 33.038 119.012 37.9406C118.947 42.8431 115.819 45.633 111.714 45.633C107.61 45.633 104.514 43.0124 104.514 37.9406V37.5455Z",
    fill: "#2B146F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3805 24.2729C71.5348 24.2729 65.6001 29.5786 65.6001 37.8436C65.2937 55.6799 93.5238 55.7445 93.2254 37.8436C93.2254 29.5786 87.2262 24.2729 79.3805 24.2729ZM79.3805 30.0222C83.759 30.0222 86.7828 33.2072 86.8473 37.7227C87.1698 44.4799 78.6952 48.0601 74.0507 43.1574C69.5673 38.5694 72.7685 29.7157 79.3886 30.0141L79.3805 30.0222Z",
    fill: "#2B146F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.071 38.5532V25.2646H136.247L136.36 39.1095C136.36 44.2621 138.61 45.8668 141.577 45.8668C144.544 45.8668 146.746 44.254 146.794 39.1095L146.907 25.2646H153.083V38.5532C153.083 47.6406 148.543 51.245 141.601 51.245C134.659 51.245 130.062 47.6406 130.062 38.5532H130.071Z",
    fill: "#2B146F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63 44.0284L157.363 48.8906C160.049 50.5436 163.161 51.358 166.306 51.2371C172.039 51.2371 176.111 48.6729 176.111 43.3753C176.111 38.6823 173.152 36.6745 168.419 35.336C165.177 34.449 163.919 33.5056 163.919 31.6591C163.919 29.8126 165.194 28.8691 167.652 28.8691C170.048 28.8852 172.386 29.6029 174.385 30.9253L176.12 26.4098C173.386 24.9826 170.346 24.2569 167.266 24.2891C161.307 24.2891 158.194 27.0146 158.194 31.6591C158.194 35.8923 160.524 38.4565 165.983 39.8516C168.879 40.6418 170.435 41.4238 170.435 43.5446C170.435 45.891 168.258 46.6651 166.032 46.6651C163.355 46.5764 160.767 45.6572 158.63 44.0364V44.0284Z",
    fill: "#2B146F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3088 62.7597L53.7657 47.2861V39.4485H49.5002V45.2944L33.3168 57.5105L16.6579 44.9316V39.4404H12.7148V47.278L33.3088 62.7517V62.7597Z",
    fill: "#2B146F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7148 20.7173L33.1718 12.8394L53.6286 20.7173V28.2727H49.5647V23.7492L33.1718 17.4355L16.7788 23.7572V28.2808H12.7148V20.7173Z",
    fill: "#2B146F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7584 20.0967H30.793V51.5441H35.7584V20.0967Z",
    fill: "url(#paint0_linear_2612_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1411 29.2686H24.1758V43.0268H29.1411V29.2686Z",
    fill: "url(#paint1_linear_2612_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0352 29.9243H49.0005V38.7689H44.0352V29.9243Z",
    fill: "url(#paint2_linear_2612_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5162 27.3037H17.5508V41.3895H22.5162V27.3037Z",
    fill: "url(#paint3_linear_2612_17545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 25.0103H42.3793V47.2856H37.4141V25.0103Z",
    fill: "url(#paint4_linear_2612_17545)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2612_17545",
    x1: 17.552,
    y1: 32.0157,
    x2: 48.9994,
    y2: 32.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5726C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71FFD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2612_17545",
    x1: 17.5553,
    y1: 32.0155,
    x2: 49.0027,
    y2: 32.0155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5726C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71FFD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2612_17545",
    x1: 17.5532,
    y1: 32.0161,
    x2: 49.0005,
    y2: 32.0161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5726C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71FFD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2612_17545",
    x1: 17.5508,
    y1: 32.0161,
    x2: 48.9982,
    y2: 32.0161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5726C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71FFD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2612_17545",
    x1: 17.5525,
    y1: 32.0157,
    x2: 48.9999,
    y2: 32.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5726C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71FFD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpus);
export default __webpack_public_path__ + "static/media/opus.4914463cbe147277cd5758a6d8aef8ff.svg";
export { ForwardRef as ReactComponent };